import styled from '@emotion/styled';
// @ts-ignore
import type * as Hls from 'hls.js';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';
import type { MicrositeResponsiveImage } from '~/model';

/* ── types ── */

interface HeroPlayer {
	html: string;
	data: string;
	type: string;
}

export interface MicrositeHeroProps {
	heroPlayer?: HeroPlayer;
	heroM3u8?: string;
	heroMp4?: string;
	image?: MicrositeResponsiveImage;
	onLoad?: () => void;
}

/* ── styled components ── */

//const PLACEHOLDER_GIF = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

const PlayerWrapper = styled.div`
	width: 100%;
	height: 100%;
	object-fit: cover;
	@media print {
		display: none;
	}
`;

const ImageContainer = styled.div`
	height: 100%;
	width: 100%;
	overflow: hidden;
	position: relative;
	background-color: white;
	@media (prefers-color-scheme: dark) {
		background-color: black;
	}
`;

const FallbackBlack = styled.div`
	height: 100%;
	width: 100%;
	background-color: black;
`;

/* ── sub-components ── */

function PlayerHero({ player }: { player: HeroPlayer }) {
	return (
		<PlayerWrapper id="player">
			<div dangerouslySetInnerHTML={{ __html: player.html }} />
			<script id="player-data" type="application/json" dangerouslySetInnerHTML={{ __html: player.data }} />
			<script defer src={`/slideshow/compiled/hydrate-${player.type}.js`} />
		</PlayerWrapper>
	);
}

export default function MicrositeHero({ heroPlayer, image, onLoad }: MicrositeHeroProps) {
	if (heroPlayer) {
		return <PlayerHero player={heroPlayer} />;
	}

	// if (heroM3u8) {
	// 	return <VideoHero m3u8={heroM3u8} mp4={heroMp4} poster={heroLarge2x} printSrc={heroLarge1x} />;
	// }

	if (image) {
		return (
			<ImageContainer>
				<MicrositeResponsiveImg priority={LoadPriority.FIRST_PAINT} image={image} onLoad={onLoad} primary />
			</ImageContainer>
		);
	}

	return <FallbackBlack />;
}
